export const NAVIGATE = 'NAVIGATION/NAVIGATE';

export const actions = {};
